import { Registry, withRegistry } from '@bem-react/di';
import { composeU, compose } from '@bem-react/core';

import {
    Participant as ParticipantBase,
    withDelete as withParticipantDelete,
    withMethodSelect as withParticipantMethodSelect,
    withTypePerson as withParticipantTypePerson,
    withTypeRoom as withParticipantTypeRoom,
    withTypeArbitrary as withParticipantTypeArbitrary,
} from 'components/Participant/desktop';

import {
    ParticipantsList as ParticipantsListBase,
    withSuggest,
    withCollapse,
    withTypeCommon,
    registryId as participantsListRegistryID,
} from 'components/ParticipantsList';

import { StreamDesktop } from './Stream';
import { TemplateFormScreenHeaderDesktop } from './Header/TemplateFormScreen-Header@desktop';
import {
    TemplateFormScreen as TemplateFormScreenBase,
    registryId as templateFormRegistryID,
} from './TemplateFormScreen';

const Participant = compose(
    withParticipantMethodSelect,
    withParticipantDelete,
    composeU(
        withParticipantTypeRoom,
        withParticipantTypePerson,
        withParticipantTypeArbitrary,
    ),
)(ParticipantBase);

const ParticipantsList = compose(
    withSuggest,
    withCollapse,
    withTypeCommon,
)((ParticipantsListBase));

const participantsListRegistry = new Registry({ id: participantsListRegistryID });
participantsListRegistry.set('Participant', Participant);

const registry = new Registry({ id: templateFormRegistryID });

registry.set('ParticipantsList', withRegistry(participantsListRegistry)(ParticipantsList));
registry.set('Header', TemplateFormScreenHeaderDesktop);
registry.set('Stream', StreamDesktop);

export const TemplateFormScreenDesktop = withRegistry(registry)(TemplateFormScreenBase);

export default TemplateFormScreenDesktop;
